export enum RegulationModuleType {
  Dashboard = "Dashboard",
  StandardQuestionnaires = "StandardQuestionnaires",
  SelfAssessments = "SelfAssessments",
  MyViews = "MyViews",
  DataManagement = "DataManagement",
  Surveys = "Surveys",
  StandardDataTables = "StandardDataTables",
  CustomDataTables = "CustomDataTables",
}
